import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../components/common/EmptyState';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="py-5">
      <EmptyState icon="bi-signpost-2" title="This page does not exist" hint="The link may be old or mistyped.">
        <Button className="btn-clinic" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </EmptyState>
    </div>
  );
}
